import { selectorFamily } from 'recoil';
import { parseTemplateListResponse } from '../adapters/templateListAdapter';
import { templateService } from '../services/templateService';
import { templateListRefreshAtom } from '../state/templateAtoms';
import { USE_WHATSAPP_REPORTING } from '../constants/reportingConfig';

export const templateListQuery = selectorFamily({
  key: 'whatsappTemplateListQuery_v2',
  get: (filters) => async ({ get }) => {
    get(templateListRefreshAtom);
    try {
      const res = await templateService.getTemplates(filters);
      if (res?.status === 200) {
        return parseTemplateListResponse(res);
      }
      throw new Error('Failed to fetch templates');
    } catch (error) {
      return { templates: [], count: 0, error: error?.message || 'Failed to fetch templates' };
    }
  },
});

export const templateSummaryQuery = selectorFamily({
  key: 'whatsappTemplateSummaryQuery_v2',
  get: (filters) => async () => {
    if (USE_WHATSAPP_REPORTING) {
      return { data: [], total_count: 0, message_counts: {}, button_list: [] };
    }
    if (!filters?.template_id) {
      return { data: [], total_count: 0, message_counts: {}, button_list: [] };
    }
    try {
      const res = await templateService.getDateWiseSummary(filters);
      if (res?.status === 200) {
        return res.data ?? { data: [], total_count: 0 };
      }
      return { data: [], total_count: 0 };
    } catch {
      return { data: [], total_count: 0 };
    }
  },
});
